(function(){
  'use strict';
  if(window.AUVENNECartClarityBound)return;
  window.AUVENNECartClarityBound=true;
  var IS_SV=(document.documentElement.lang||'').toLowerCase().indexOf('sv')===0;
  function ui(nl,sv){return IS_SV?sv:nl;}

  var VALUE_MAP=IS_SV?{
    'Gold tone':'Guldfärgad','Gold Tone':'Guldfärgad','Gold Color':'Guldfärgad',
    'Silver tone':'Silverfärgad','Silver Tone':'Silverfärgad','Silver Color':'Silverfärgad',
    'One Size':'En storlek','Off-white':'Offwhite','Mixed colour':'Flerfärgad',
    'Pink':'Rosa','Rose Red':'Rödrosa','Red':'Röd','Green':'Grön','Purple':'Lila',
    'Black':'Svart','White':'Vit','Blue':'Blå','Brown':'Brun',
    'Goudkleur':'Guldfärgad','Zilverkleur':'Silverfärgad','Eén maat':'En storlek','Gebroken wit':'Offwhite','Meerkleurig':'Flerfärgad',
    'Roze':'Rosa','Rozerood':'Rödrosa','Rood':'Röd','Groen':'Grön','Paars':'Lila',
    'Zwart':'Svart','Wit':'Vit','Blauw':'Blå','Bruin':'Brun'
  }:{
    'Gold tone':'Goudkleur','Gold Tone':'Goudkleur','Gold Color':'Goudkleur',
    'Silver tone':'Zilverkleur','Silver Tone':'Zilverkleur','Silver Color':'Zilverkleur',
    'One Size':'Eén maat','Off-white':'Gebroken wit','Mixed colour':'Meerkleurig',
    'Pink':'Roze','Rose Red':'Rozerood','Red':'Rood','Green':'Groen','Purple':'Paars',
    'Black':'Zwart','White':'Wit','Blue':'Blauw','Brown':'Bruin'
  };
  var OPTION_MAP=IS_SV?{'Kleur':'Färg','Color':'Färg','Colour':'Färg','Maat':'Storlek','Size':'Storlek','Materiaal':'Material','Material':'Material','Lengte':'Längd','Length':'Längd','Stijl':'Stil','Style':'Stil'}:{'Färg':'Kleur','Color':'Kleur','Colour':'Kleur','Storlek':'Maat','Size':'Maat','Material':'Materiaal','Längd':'Lengte','Length':'Lengte','Stil':'Stijl','Style':'Stijl'};
  var lastCart=null;
  var syncing=false;
  var pendingSync=false;
  var repairQueued=false;

  function rootPath(){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
    return root.charAt(root.length-1)==='/'?root:root+'/';
  }
  function drawer(){return document.querySelector('cart-drawer');}
  function formatMoney(cents){var amount=(Number(cents)||0)/100;var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)?Shopify.currency.active:(IS_SV?'SEK':'EUR');try{return new Intl.NumberFormat(IS_SV?'sv-SE':'nl-NL',{style:'currency',currency:currency}).format(amount);}catch(e){return amount.toFixed(2);}}
  function translatedValue(value){var clean=(value||'').trim();var suffix=/,$/.test(clean)?',':'';var bare=clean.replace(/,$/,'').trim();return (VALUE_MAP[bare]||bare)+suffix;}
  function translatedOption(value){var clean=(value||'').trim().replace(/:$/,'');return OPTION_MAP[clean]||clean;}

  function normalizeCartVariants(node){
    if(!node)return;
    node.querySelectorAll('.product-option dt').forEach(function(el){
      var next=translatedOption(el.textContent)+':';
      if(el.textContent.trim()!==next)el.textContent=next;
    });
    node.querySelectorAll('.product-option dd').forEach(function(el){
      var next=translatedValue(el.textContent);
      if(next&&el.textContent.trim()!==next)el.textContent=next;
    });
    node.querySelectorAll('.discounts__discount').forEach(function(el){
      var value=(el.textContent||'').trim();
      var next=value;
      if((value.indexOf('Build Your Stack — 25% on 3 or more')>-1||value.indexOf('−25% (3+)')>-1))next=ui('25% combinatiekorting','25 % kombinationsrabatt');
      else if((value.indexOf('Build Your Stack — 15% on 2 or more')>-1||value.indexOf('−15% (2+)')>-1))next=ui('15% combinatiekorting','15 % kombinationsrabatt');
      if(next!==value)el.textContent=next;
    });
  }

  function normalizeCopy(node){
    if(!node)return;
    node.querySelectorAll('.auv-drawer__notice-main,.auv-drawer__notice-sub').forEach(function(el){
      var value=el.textContent||'';
      if(/stackkorting/i.test(value))el.textContent=value.replace(/stackkorting/gi,'combinatiekorting');
    });
    var tax=node.querySelector('.tax-note');
    var taxText=ui('Verzendkosten en het definitieve totaal staan bij afrekenen.','Fraktkostnad och slutligt totalbelopp visas i kassan.');
    if(tax&&tax.textContent.trim()!==taxText)tax.textContent=taxText;
    node.querySelectorAll('.auv-drawer__trust span').forEach(function(el){
      var raw=(el.textContent||'').trim();
      if(raw.indexOf('✓ 30 dagen retour')===0||raw.indexOf('✓ 30 dagars returrätt')===0){
        var returns=ui('✓ 30 dagen retour · 60 dagen voor leden','✓ 30 dagars returrätt · 60 dagar för medlemmar');
        if(raw!==returns)el.textContent=returns;
      }
    });
    normalizeCartVariants(node);
  }

  function submitCheckout(inner){
    var footer=inner&&inner.querySelector('.drawer__footer');
    var checkout=footer&&footer.querySelector('#CartDrawer-Checkout');
    if(!checkout||checkout.disabled)return;
    var form=checkout.form||document.getElementById('CartDrawer-Form');
    if(form&&typeof form.requestSubmit==='function')form.requestSubmit(checkout);
    else checkout.click();
  }

  function ensureCheckoutDock(inner,footer){
    if(!inner)return;
    var original=footer?footer.querySelector('#CartDrawer-Checkout'):null;
    var dock=inner.querySelector(':scope > .auv-drawer__checkout-dock');
    if(!original){if(dock)dock.remove();return;}

    var originalCtas=original.closest('.cart__ctas');
    if(originalCtas)originalCtas.setAttribute('data-auv-original-ctas','');

    if(!dock){
      dock=document.createElement('div');
      dock.className='auv-drawer__checkout-dock';
      dock.setAttribute('data-auv-checkout-dock','');
      dock.innerHTML='<button type="button" class="auv-drawer__checkout-button">'+ui('Afrekenen','Till kassan')+'</button>';
      inner.appendChild(dock);
      dock.addEventListener('click',function(event){
        var button=event.target.closest('.auv-drawer__checkout-button');
        if(!button||button.disabled)return;
        submitCheckout(inner);
      });
    }

    var dockButton=dock.querySelector('.auv-drawer__checkout-button');
    var disabled=!!original.disabled;
    dock.hidden=disabled;
    if(dockButton){
      var label=ui('Afrekenen','Till kassan')+(lastCart&&Number(lastCart.total_price)>0?' · '+formatMoney(lastCart.total_price):'');
      if(dockButton.textContent.trim()!==label)dockButton.textContent=label;
      dockButton.disabled=disabled;
      dockButton.setAttribute('aria-disabled',disabled?'true':'false');
    }
  }

  function ensureLayout(node){
    if(!node)return;
    var inner=node.querySelector('.drawer__inner');
    if(!inner)return;
    var header=inner.querySelector('.drawer__header');
    var items=inner.querySelector('cart-drawer-items');
    var footer=inner.querySelector('.drawer__footer');
    var scroll=inner.querySelector(':scope > .auv-drawer__scroll');

    if(!items||!footer){
      if(scroll&&scroll.children.length===0)scroll.remove();
      ensureCheckoutDock(inner,null);
      return;
    }

    if(!scroll){
      scroll=document.createElement('div');
      scroll.className='auv-drawer__scroll';
      scroll.setAttribute('data-auv-drawer-scroll','');
      if(header&&header.nextSibling)inner.insertBefore(scroll,header.nextSibling);
      else if(header)header.insertAdjacentElement('afterend',scroll);
      else inner.prepend(scroll);
    }
    if(items.parentElement!==scroll)scroll.appendChild(items);
    if(footer.parentElement!==scroll)scroll.appendChild(footer);
    ensureCheckoutDock(inner,footer);
  }

  function repair(){
    repairQueued=false;
    var node=drawer();
    if(!node)return;
    ensureLayout(node);
    normalizeCopy(node);
  }

  function queueRepair(){
    if(repairQueued)return;
    repairQueued=true;
    window.requestAnimationFrame(repair);
  }

  function apply(cart){
    if(cart&&Array.isArray(cart.items))lastCart=cart;
    repair();
  }

  function sync(){
    if(syncing){pendingSync=true;return;}
    syncing=true;
    fetch(rootPath()+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(response){if(!response.ok)throw new Error('cart sync');return response.json();})
      .then(apply)
      .catch(function(){repair();})
      .finally(function(){syncing=false;if(pendingSync){pendingSync=false;sync();}});
  }

  function observe(){
    var node=drawer();
    if(!node||node.dataset.auvClarityObserved==='1')return;
    node.dataset.auvClarityObserved='1';
    new MutationObserver(queueRepair).observe(node,{childList:true,subtree:true});
    repair();
    sync();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',observe);else observe();
  document.addEventListener('shopify:section:load',function(){observe();queueRepair();});
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
    subscribe(PUB_SUB_EVENTS.cartUpdate,function(event){
      if(event&&event.cartData&&Array.isArray(event.cartData.items)){apply(event.cartData);}
      else sync();
    });
  }
  document.addEventListener('auvenne:cart-synced',function(event){
    var cart=event&&event.detail&&event.detail.cart;
    if(cart&&Array.isArray(cart.items))apply(cart);
  });
})();
